/**
 * 현재 dev 진행률 기준 예상 손실률 추정
 */
export function estimateCurrentLoss(currDevTime: number, refDevTime: number, refFinalLoss: number): number {
  const progress = Math.min(currDevTime / refDevTime, 1);
  return progress * refFinalLoss;
}

/**
 * 단위 시간당 손실 증가율 계산
 * (실시간 추세 파악용)
 */
export function computeLossSlope(currLoss: number, prevLoss: number, deltaTime: number): number {
  if (deltaTime <= 0) return 0;
  return (currLoss - prevLoss) / deltaTime;
}
